import React from 'react'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify'
import qs from 'qs'
import irelandApi from '../irelandApi'
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'

export const getCategories = (query, action = 'GET_CATEGORY_LIST') => (dispatch) => {
  dispatch({type: `${action}_PENDING`});
  const q = {
    category: query
  };
  return irelandApi.get(`/api/admin/categories?${qs.stringify({q: q}, {encodeValuesOnly: true})}`)
                   .then((response) => {
                     dispatch({type: `${action}_FULFILLED`, payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: `${action}_REJECTED`, payLoad: error.data})
                   })
};

export const reorderCategories = (payLoad) => (dispatch) => {
  // dispatch({type: "REORDER_CATEGORIES_PENDING"});
  dispatch({type: "REORDER_CATEGORIES_FULFILLED", payLoad: {data: payLoad}});
  const data = {
    order: payLoad.map(item => +item.id)
  };
  return irelandApi.patch(`/api/admin/categories/change_order`, {category: data})
                   .then((response) => {
                     toast.info(<ToastMessage iconStyle="info" message="Category order modified"/>, {autoClose: 2000});
                   })
                   .catch((error) => {
                     toast.warn(<ToastMessage iconStyle="warning" message="Unable to set category order"/>, {autoClose: 2000});
                     dispatch({type: 'REORDER_CATEGORIES_REJECTED', payLoad: error.data})
                   })
};

export const getCategory = (id) => (dispatch) => {
  dispatch({type: "GET_CATEGORY_PENDING"});
  return irelandApi.get(`/api/admin/categories/${id}`)
                   .then((response) => {
                     const attributes = response.data.data.attributes;
                     const category = {
                       name: attributes.name || ''
                     };
                     dispatch(actions.load('deep.admin_category', category));
                     dispatch({type: "GET_CATEGORY_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_CATEGORY_REJECTED', payLoad: error.data})
                   })
};

export const deleteCategory = (id) => (dispatch) => {
  dispatch({type: "DELETE_CATEGORY_PENDING"});
  return irelandApi.delete(`/api/admin/categories/${id}`)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Category has been deleted successfully"/>);
                     dispatch({type: "DELETE_CATEGORY_FULFILLED", payLoad: id});
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occured during delete category"/>);
                     dispatch({type: 'DELETE_CATEGORY_REJECTED', payLoad: error.data});
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data);
                   })
};

const prepareCategoryFormData = (payLoad) => {
  let formData = new FormData();
  Object.keys(payLoad).forEach(key => {
      formData.append(`category[${key}]`, payLoad[key])
  });
  return formData;
};

export const saveCategory = (payLoad) => {
  let formData = prepareCategoryFormData(payLoad);
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };
  return irelandApi.post('/api/admin/categories/', formData, config)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Category has been saved successfully"/>);
                     history.push('/admin/categories');
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occurred during save category"/>);
                     store.dispatch(actions.resetValidity('deep.admin_category'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   })
};


export const updateCategory = (id, payLoad) => {
  let formData = prepareCategoryFormData(payLoad);
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };
  return irelandApi.patch(`/api/admin/categories/${id}`, formData, config)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Category has been saved successfully"/>);
                     history.push('/admin/categories');
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occurred during save category"/>);
                     store.dispatch(actions.resetValidity('deep.admin_category'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   })
};



// WEBPACK FOOTER //
// ./src/actions/categories.js